import './style/hideProductDialog.scss';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {nullify} from '@dvrd/dvr-controls';
import BolProduct from '../../../models/bolProductModel';
import {BluemateButton, BluemateCheckbox, BluemateDialog} from '../../controls';

interface Props {
    onClose: VoidFunction;
    onConfirm: VoidFunction;
    onCheckLists: (checked: boolean) => void;
    onCheckChannels: (checked: boolean) => void;
    onCheckDontShowAgain: (checked: boolean) => void;
    active: boolean;
    product: BolProduct | null;
    acknowledgedLists: boolean;
    acknowledgedChannels: boolean;
    dontShowAgain: boolean;
    canDismissPermanently: boolean;
}

export default function HideProductDialog(props: Props) {
    const {
        onClose,
        onConfirm,
        onCheckLists,
        onCheckChannels,
        onCheckDontShowAgain,
        active,
        product,
        acknowledgedLists,
        acknowledgedChannels,
        dontShowAgain,
        canDismissPermanently
    } = props;
    const {t} = useTranslation();
    const canConfirm = acknowledgedLists && acknowledgedChannels;

    function renderFooter() {
        return (
            <>
                <BluemateButton label={t('products.hideDialog.cancel', 'Annuleren')} onClick={onClose} tertiary />
                <BluemateButton
                    label={t('products.hideDialog.confirm', 'Verbergen')}
                    onClick={onConfirm}
                    disabled={!canConfirm}
                    color='red'
                />
            </>
        );
    }

    return (
        <BluemateDialog
            active={active}
            onClose={onClose}
            title={t('products.hideDialog.title', 'Product verbergen?')}
            footer={renderFooter()}
            className='hide-product-dialog'
            width='32rem'
        >
            {!!product && (
                <div className='hide-product-name'>
                    <span className='product-title'>{nullify(product.title) ?? product.ean}</span>
                    <span className='product-ean'>EAN: {product.ean}</span>
                </div>
            )}
            <p className='hide-product-text'>
                {t(
                    'products.hideDialog.body',
                    'Het product wordt niet meer getoond in de lijsten en overzichten van Bluemate en wordt niet meer gebruikt in e-mails, notificaties enzovoort. Deze optie is bedoeld voor producten die je niet meer verkoopt of niet meer wilt zien. Je kunt het product hier altijd weer tonen. Deze wijziging geldt alleen voor Bluemate en niet voor bol zelf.'
                )}
            </p>
            <div className='hide-product-checks'>
                <BluemateCheckbox
                    checked={acknowledgedLists}
                    onCheck={onCheckLists}
                    label={t(
                        'products.hideDialog.ackLists',
                        'Ik begrijp dat ik dit product niet meer zie in lijsten en overzichten.'
                    )}
                />
                <BluemateCheckbox
                    checked={acknowledgedChannels}
                    onCheck={onCheckChannels}
                    label={t(
                        'products.hideDialog.ackChannels',
                        'Ik begrijp dat dit product niet meer wordt meegenomen in e-mails en notificaties. Als het nu is opgenomen, wordt het uitgesloten.'
                    )}
                />
            </div>
            {canDismissPermanently && (
                <BluemateCheckbox
                    checked={dontShowAgain}
                    onCheck={onCheckDontShowAgain}
                    label={t('products.hideDialog.dontShowAgain', 'Niet meer tonen')}
                    className='hide-product-dismiss'
                />
            )}
        </BluemateDialog>
    );
}
